// src/Components/NetworkErrorPage.tsx
import { Button, Result } from "antd";
import { useEffect } from "react";

interface NetworkErrorPageProps {
  onRetry: () => void;
}

const NetworkErrorPage = ({ onRetry }: NetworkErrorPageProps) => {
  useEffect(() => {
    let hasRetried = false;

    const interval = setInterval(() => {
      if (navigator.onLine && !hasRetried) {
        hasRetried = true;
        onRetry();
        clearInterval(interval);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [onRetry]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Result
        status="warning"
        title="No Internet Connection"
        subTitle="Please check your network connection and try again."
        extra={
          <Button type="primary" onClick={onRetry} disabled={!navigator.onLine}>
            Retry
          </Button>
        }
      />
    </div>
  );
};

export default NetworkErrorPage;
